function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 92,
  height: 92,
  rx: 25.2626,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M53.3353 30C51.1372 30 49.0452 30.4594 47.149 31.2887C48.1128 31.9345 49.0198 32.685 49.8551 33.5325C53.1112 36.8346 54.9028 41.2267 54.9028 45.8963H53.3368C53.3368 40.0138 50.1868 34.8758 45.5022 32.1286C44.9733 31.8148 44.4234 31.5358 43.8555 31.2887C41.9578 30.4594 39.8658 30 37.6677 30C29.0142 30 22 37.1166 22 45.8963C22 54.676 29.0142 61.7926 37.6677 61.7926C39.8658 61.7926 41.9578 61.3332 43.854 60.5039C42.8902 59.8581 41.9832 59.1076 41.1479 58.2616C37.8918 54.9595 36.1001 50.5674 36.1001 45.8978H37.6662C37.6662 51.7818 40.8161 56.9183 45.4993 59.6655C46.0282 59.9793 46.5781 60.2583 47.146 60.5054C49.0437 61.3347 51.1342 61.7941 53.3323 61.7941C61.9858 61.7941 69 54.6776 69 45.8978C69 37.1181 61.9888 30 53.3353 30Z",
  fill: "#AB6976"
});

var SvgDeema = function SvgDeema(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeema, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/deema.4d958e03.svg";
export { ForwardRef as ReactComponent };